export class ItemAttributeSetLink {
  attributeSetAttributeLink: any;
  attributeGuid: string;
  attributeName: string;
  attributeType: string;
  attributeCode: string;
  qty: number;
}
